import React, { useRef } from 'react'
import classNames from 'classnames'
import { ErrorMessage } from '../error_message'
import { FormTextareaProps } from './types'
import { FormValues } from 'donate/types'
import { useTextareaAutosize } from 'shared'

export const FormTextArea = ({ field, form: { touched, errors }, ...props }: FormTextareaProps): JSX.Element => {
  const hasError = touched[field.name] && errors[field.name]
  const classes = classNames(props.className, 'form-control', { 'field-with-error': hasError })
  const groupClass = `donate-form-group-${field.name.replace('_', '-')}`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const textAreaProps: any = { ...field, ...props }
  const textarea = useRef<HTMLTextAreaElement>(null)
  useTextareaAutosize(textarea.current)

  return (
    <div className={classNames('form-group', groupClass)}>
      <label className="control-label sr-only" htmlFor={field.name}>
        {props.placeholder}
      </label>
      <textarea id={field.name} className={classes} {...textAreaProps} ref={textarea} rows={1} />
      <ErrorMessage field={field.name as keyof FormValues} />
    </div>
  )
}
